import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M.833 8S4.167 1.333 10 1.333 19.167 8 19.167 8 15.833 14.667 10 14.667.833 8 .833 8"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M10 10.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    }, null, -1)
  ]))]))
}
export default { render: render }